var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoParentalRating18 = function SvgIcoParentalRating18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M12 24c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12S0 5.373 0 12c0 6.628 5.372 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.044 4.793c3.969 0 7.195 3.228 7.195 7.197s-3.226 7.197-7.195 7.197a7.204 7.204 0 0 1-7.197-7.197 7.204 7.204 0 0 1 7.197-7.197m0-2.399c-5.301 0-9.597 4.296-9.597 9.596s4.296 9.596 9.597 9.596 9.595-4.296 9.595-9.596-4.295-9.596-9.595-9.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.587 9.958h-.5c-.494 0-.74-.374-.74-.738s.246-.739.74-.739h1.298c.364 0 .797.138.797.798v5.426c0 .562-.334.846-.797.846-.462 0-.798-.284-.798-.846zm7.29.335c0 .69-.414 1.2-.65 1.389.65.394.944 1.043.944 1.683 0 1.28-1.014 2.285-2.57 2.285s-2.57-1.005-2.57-2.285c0-.64.295-1.29.945-1.683-.237-.188-.65-.7-.65-1.39 0-1.299 1.053-1.969 2.275-1.969s2.275.67 2.275 1.97m-2.276 3.82a.907.907 0 0 0 .916-.915.91.91 0 0 0-.916-.916.91.91 0 0 0-.916.915c0 .514.404.916.916.916m0-3.013c.364 0 .68-.314.68-.68a.694.694 0 0 0-.68-.679.694.694 0 0 0-.68.68c0 .365.316.679.68.679"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoParentalRating18;